import { DeviceManifest } from '@rapoo/device-sdk'
import {
  baseChannel0To7,
  baseChildDeviceDisabled,
  baseScreenDisabled,
} from './generate/capabilityPresets'
import { p5BaseLightBandEffects } from './generate/lightingPresets'

/**
 * P5 PLUS 底座设备清单
 */
const rapooP5PLUS: DeviceManifest = {
  channel: ['china_game', 'global'],
  model: 'P5 PLUS',
  mainControl: 'P5 PLUS',
  type: 'base',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: 0x4827,
    currentPid: 0x4827,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 14,
        description: 'Base WebHID Command Interface',
        type: 'default',
      },
      {
        usagePage: 65519,
        usage: 0,
        description: 'Telink Base Firmware Update Interface',
        type: 'update',
      },
    ],
  },
  driver: 'Telink_Base',
  ui: {
    assetsDir: 'manifests/P5 PLUS',
    colors: {
      series: [
        {
          name: 'common.products.P5_PLUS.Black',
          value: '#2B2B2B',
          key: 'Black',
        },
        {
          name: 'common.products.P5_PLUS.White',
          value: '#F8FAFF',
          key: 'White',
        },
        {
          name: 'common.products.P5_PLUS.Raspberry_Pink',
          value: '#FF2558',
          key: 'Raspberry_Pink',
        },
        {
          name: 'common.products.P5_PLUS.Flame_Orange',
          value: '#FF672E',
          key: 'Flame_Orange',
        },
      ],
      current: 'Black',
    },
    icon: 'Hardware-Wireframe-Base',
    overview: true,
  },
  capabilities: [
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: p5BaseLightBandEffects,
      },
    },
    baseScreenDisabled,
    baseChannel0To7,
    baseChildDeviceDisabled,
  ],
  layout: {
    image: 'devices/base/base.png',
    keys: [],
  },
}

export default rapooP5PLUS
